/* eslint-disable @angular-eslint/directive-selector */
import { AfterViewInit, Directive, ElementRef, Input, NgZone } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { Tooltip } from 'primeng/tooltip';

/*
 This directive overrides the primeNg Tooltip logic and provides a tooltip that activates on both hover and focus
  instead of just hover. This addresses an accessibility defect in Primeng 8-13.
  https://github.com/primefaces/primeng/issues/9526
*/
@Directive({
  selector: '[accelaTooltip]',
})
export class AccelaTooltipDirective extends Tooltip implements AfterViewInit {
  @Input()
  set accelaTooltip(text: string) {
    this._tooltipOptions.tooltipLabel = text;
  }

  constructor(public el: ElementRef, public zone: NgZone, config: PrimeNGConfig) {
    super(el, zone, config);
  }


  public ngAfterViewInit(): void {
    //runOutsideAngular lets you exit Angular's zone.js event/change detection handling
    //to only be used to avoid cascading effects that might eat too much performance
    this.zone.runOutsideAngular(() => {
      switch (this.getOption('tooltipEvent')) {
        case 'hover':
          this.initHoverForTooltipEvent();
          break;
        case 'focus':
          this.initFocusForTooltipEvent();
          break;
        case 'hover|focus':
          this.initHoverForTooltipEvent();
          this.initFocusForTooltipEvent();
          break;
      }
    });
  }

  private initHoverForTooltipEvent(): void {
    this.mouseEnterListener = this.onMouseEnter.bind(this);
    this.mouseLeaveListener = this.onMouseLeave.bind(this);
    this.clickListener = this.onClick.bind(this);
    this.el.nativeElement.addEventListener('mouseenter', this.mouseEnterListener);
    this.el.nativeElement.addEventListener('mouseleave', this.mouseLeaveListener);
    this.el.nativeElement.addEventListener('click', this.clickListener);
  }

  private initFocusForTooltipEvent(): void {
    this.focusListener = this.onFocus.bind(this);
    this.blurListener = this.onBlur.bind(this);
    this.el.nativeElement.addEventListener('focus', this.focusListener);
    this.el.nativeElement.addEventListener('blur', this.blurListener);
    }

}
